import React from 'react';
import CompanyCard from './CompanyCard';
import { USE_V2_DESIGN } from '@rd-web-markets/market/dist/constants';
const CompanyList = _ref => {
  let {
    models,
    accountType,
    refreshCompanies,
    CompanyCardActionButtons,
    CompanyCardHeader,
    deleteCompanyGroup,
    setLoading,
    type = 'company'
  } = _ref;
  const to = companyId => {
    if (type === 'company') {
      return USE_V2_DESIGN ? `/${accountType}/companies/${companyId}/overview` : `/${accountType}/companies/${companyId}/master`;
    } else {
      return `/${accountType}/company_groups/${companyId}/`;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "company-cards-container"
  }, models.map(model => {
    return /*#__PURE__*/React.createElement(CompanyCard, {
      key: model.id,
      model: model,
      deleteCompanyGroup: deleteCompanyGroup,
      accountType: accountType,
      refreshCompanies: refreshCompanies,
      CompanyCardHeader: CompanyCardHeader,
      CompanyCardActionButtons: CompanyCardActionButtons,
      setLoading: setLoading,
      to: to(model.id),
      type: type
    });
  }));
};
export default CompanyList;